import { render, staticRenderFns } from "./MarketingManager.vue?vue&type=template&id=72fe031d&scoped=true"
import script from "./MarketingManager.vue?vue&type=script&lang=js"
export * from "./MarketingManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72fe031d",
  null
  
)

export default component.exports